import React, { useEffect, useState } from 'react'
import axios from "axios"
import { XIcon } from '@heroicons/react/solid'
const ItemCosting = ({ isItemReportSummary, setItemReportSummary }) => {
    const [ItemCostingData, setItemCostingData] = useState([])
    const [showList, setShowList] = useState(false)
    const getItemCostingData = async () => {
        let outlet_uuid = localStorage.getItem("outlet_uuid")
        const response = await axios({
            method: "get",
            url: `https://api.myfooddo.com/item/item_costing/${outlet_uuid}`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },

        })
        if (response.data.success)
            setItemCostingData(response.data.result)
        console.log(response)
    }
    useEffect(() => {
        getItemCostingData()
    }, [])
    const submiteHandler=async()=>{
        let outlet_uuid = localStorage.getItem("outlet_uuid")
        const response = await axios({
            method: "put",
            url: `https://api.myfooddo.com/item/putItemCost`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            data:{
                data:ItemCostingData,
                outlet_uuid
            }

        })
        console.log(response)
        setItemReportSummary(false)
    }
    return (
        <div className="itemavilablelity" style={{marginLeft:"10vw"}}>
            <div className="itemavilabelitycontainer">
                <div className="itemavilablelity_header">
                    <h2 style={{ width: "80%" }}>Item Report</h2>
                    <XIcon style={{ width: "25px" }} onClick={() => setItemReportSummary(false)} />
                </div>
                {showList ? <><div className="availablecontainer">
                    <div className="itemavilablelitybox">

                        <div className="items_table">
                            <table className="f6 w-100 center" cellSpacing="0">
                                <thead className="lh-copy">
                                    <tr className="white">
                                        <th className="pa3 bb b--black-20 ">Item</th>
                                        <th className="pa3 bb b--black-20 " >Cost</th>
                                    </tr>
                                </thead>
                                <tbody className="lh-copy">
                                    {ItemCostingData
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td className="ph3 bb b--black-20 tc bg-white">{item.item_name}</td>
                                                <td className="ph3 bb b--black-20 tc bg-white" >
                                                    <input
                                                        value={item.item_costing}
                                                        onChange={e =>
                                                            setItemCostingData(ItemCostingData.map(a => a.item_uuid === item.item_uuid
                                                                ? ({ ...a, item_costing: e.target.value }) : a)
                                                            )
                                                        }
                                                    />

                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> <div onClick={submiteHandler}>
                        <button className="savebtn">
                            Update
                        </button>
                    </div></> :
                    <><div className="availablecontainer" style={{flexDirection:"column",justifyContent:"flex-start"}}>
                        <h2>{ItemCostingData.filter(a => +a.item_costing===0).length + "/" + ItemCostingData.length + " "} Items have Costing Value 0</h2>
                        <div onClick={() => setShowList(true)} style={{ width: "100%", textAlign: "center", cursor: "pointer", color: "blue" }}><u>Show list</u> </div>
                    </div>
                        <div >
                            <button onClick={() => setItemReportSummary(false)} className="savebtn">
                                Close
                            </button>
                        </div></>}
            </div>
        </div>

    )
}

export default ItemCosting